export const prodConfiguration = {
  getLogin: "/admin/signIn",
  forgotPassword: "/admin/forgetPassword",
  verifyOtp: "/admin/verifyOTP",
  resetPassword: "/admin/resetPassword",
  getCMSoverview: "/admin/getCMS?type=overview",
  getCMSformatview: "/admin/getCMS?type=format_rules",
  updateCMS: "/admin/updateCMS",
  addVenue: "/admin/addVenue",
  getVenuelist: "/admin/viewVenueList",
  getVenueById: "/admin/viewVenue",
  updateVenue: "/admin/updateVenue",
  addNews: "/admin/createNews",
  getNewslist: "/admin/newsList",
  updateNewsState: "/admin/updateNewsStatus",
  updateNews: "/admin/updateNews",
  viewNews: "/admin/newsDetails",
  newsDetails: "/admin/newsDetails",
  addTeam: "/admin/addTeam",
  deleteNews: "/admin/deleteNews",
  newsList: "/user/newsList",
  userBannerList: "/user/bannerList",
  partnerStreamList: "/user/partnerStreamList",
  partnerUpdateList: "/user/getPartnerUpdateList",
  partnerUpdateTypeList: "/user/partnerUpdateTypeList",
  getContent: "/user/getContent",
  getSoundTrackBookingTicket: "/user/getSoundTrackBookingTicket",
  saudiaCompetitionList: "/user/saudiaCompetitionList",
  saudiaCompetitionDetails: "/user/saudiaCompetitionDetails",
  saudiaMomentList: "/user/saudiaMomentList",
  saudiaMomentDetails: "/user/saudiaMomentDetails",
  winTicketList: "/user/winTicketList",
  userNewsDetails: "/user/newsDetails",
  userPartnerUpdateDetails: "/user/partnerUpdateDetails",
  addWinForm: "/user/addWinForm",
  formMasterList: "/user/formMasterList",
  storeUserForm: "/user/storeUserForm",
  quizList: "/user/quizeList",
  quizDetails: "/user/quizeDetails",
  submitUserPrediction: "/user/submitUserPrediction",
  surveyQuestionsList: "/user/surveyQuestionsList",
  submitPredictSurvey: "/user/submitPredictSurvey",
  getUserByToken: "/user/getUserByToken",
  updatePredictScore: "/user/updatePredictScore",
  countryList: "/user/countryList",
  getUserById: "/user/getUserById",
};
export const prodAbiConfig = {};
